import React, { Component } from 'react';
import DragDropFunctions from '../../../dragDropFunctions';
import IncAddCustomField from '~/pages/cp/subscribers/customfields/incAddCustomField'
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import { connect } from 'react-redux';
import Avatar from '~/Common-Objects/Avatar/Avatar';
import Select from '~/Common-Objects/UI/Forms/Select/Select';
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder';
import i18n from '~/i18n';
import { forcedNewFieldType } from '~/utils/fieldTypeLabel';

@connect((store) => {
    return { user: store.user }
})

class CustomField extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currVal: "",
            customFields: {},
            pageLoaded: false,
            fieldTypesDisabled: []
        }
        this.addField = this.addField.bind(this);
        this.createdField = this.createdField.bind(this);
        this.generateCustomFields = this.generateCustomFields.bind(this);
        this.change = this.change.bind(this);
    }

    change(value) {

        if (typeof value == "object") {
            value = value.currentTarget.value;
        }
        var thisDataFieldName = Object.keys(DragDropFunctions.customFields).find(theField => theField == value);
        var thisVal = "";
        var thisLabel = " ";
        var thisRequired = false;
        var thisFieldType = " ";

        if (thisDataFieldName) {
            var thisData = DragDropFunctions.customFields[thisDataFieldName];
            thisVal = thisDataFieldName;
            thisLabel = thisData.description;
            thisRequired = thisData.required;
            thisFieldType = thisData.type;
        }
        this.props.updateVal(this.props.path, { value: thisVal, label: thisLabel, required: thisRequired, fieldType: thisFieldType }, undefined, undefined);
    }

    componentDidMount() {
        this.generateCustomFields(this.props);
    }
    componentWillReceiveProps(nextProps) {
        this.generateCustomFields(nextProps);
        this.setState({ currVal: nextProps.value })
    }

    generateCustomFields(theProps) {
        var customFieldData = JSON.parse(JSON.stringify(DragDropFunctions.customFields));
        var elementsData = theProps.elementsData;

        for (const prop in customFieldData) {
            if (customFieldData[prop].readOnly) delete customFieldData[prop];
        }

        for (var x in customFieldData) {
            customFieldData[x].disabled = false;
            customFieldData[x].tooltip = '';
        }

        let fieldTypesDisabledTmp = [];
        if (this.props.elementData && this.props.elementData.fieldTypesDenied && typeof this.props.elementData.fieldTypesDenied == "object") {
            fieldTypesDisabledTmp = this.props.elementData.fieldTypesDenied;
        }
        if (this.props.elementData && this.props.elementData.fieldTypesDisabled && typeof this.props.elementData.fieldTypesDisabled == "object") {
            this.props.elementData.fieldTypesDisabled.forEach(theDen => {
                if (fieldTypesDisabledTmp.indexOf(theDen) == -1) fieldTypesDisabledTmp.push(theDen);
            })
        }

        if (fieldTypesDisabledTmp && fieldTypesDisabledTmp.length > 0) {
            Object.keys(customFieldData).forEach(theField => {
                fieldTypesDisabledTmp.forEach(theDen => {
                    if (theDen == customFieldData[theField]?.type) delete customFieldData[theField];
                })

            })
        }

        function checkNode(thisJson) {
            if (Array.isArray(thisJson)) {
                thisJson.forEach((ele, index) => {
                    if (typeof ele === "object") {
                        checkNode(ele);
                    }
                })
            }
            else {

                Object.keys(thisJson).forEach(ele => {
                    if (typeof thisJson[ele] == "object" && thisJson[ele]) {
                        if (thisJson[ele].editableType === "CustomField") {
                            var thisCustField = thisJson[ele].value;
                            if (customFieldData[thisCustField]) {

                                customFieldData[thisCustField].disabled = true;
                            }
                        }
                        checkNode(thisJson[ele]);
                    }
                })
            }
        }

        checkNode(elementsData);

        this.setState({ customFields: customFieldData, pageLoaded: true, currVal: theProps.value, fieldTypesDisabled: fieldTypesDisabledTmp })

    }


    addField() {

        var drawerContent = <IncAddCustomField getCustomFields={this.createdField} excludeFieldsTypes={this.state.fieldTypesDisabled} forceType={forcedNewFieldType({ selectedType: this.state.customFields[this.state.currVal]?.type, allowMulti: this.props.localVariables?.allowMulti?.value })} standalone={true} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", drawerContent, true, "500px", undefined));
    }

    createdField(newField) {
        var customFieldId = "customField-" + newField.id;
        var self = this;
        DragDropFunctions.getCustomFields(DragDropFunctions.templateType).then(() => {
            self.props.dispatch(siteMaster.alterSiteDrawer(false, true, "right", null, true));
            self.change(customFieldId)
        })
    }

    render() {
        if (!this.state.pageLoaded) return <div></div>;
        const tempCustomFields = this.state.customFields;
        var options = [{
            value: '',
            label: 'Select Field'
        }].concat(Object.keys(tempCustomFields).map(row => {
            return {
                value: row,
                label: tempCustomFields[row].description,
                disabled: tempCustomFields[row].disabled,
                iconRight: tempCustomFields[row].Application ? <Avatar src={tempCustomFields[row].Application.appLogoUri} style={{ height: 20, width: 20 }} /> : null,
                tooltip: tempCustomFields[row].tooltip
            }

        }))

        var classes = "dd_dragDrop";
        const fieldError = this.props.error ? i18n.t('templates:add.drag.missingField') : '';
        var style = {};
        if (this.props.elementData.optionFullWidth) style = { flex: "100%" }

        const selected = this.state.customFields[this.state.currVal]

        return <div className="dd_toolHolder" style={style}>
            <div className="dd_inputTool">

                <Select filter={true} fixedHeightLarge={true} label={this.props.title} data={options} className={classes} onChange={this.change} value={this.state.currVal} error={fieldError} />
                {selected && selected.helper && <WarningHolder className="mar-t10">{selected.helper}</WarningHolder>}
                <div className="text-right mar-t10 text-xsml">
                    <a onClick={this.addField}>Create new Field</a>
                </div>

            </div>


        </div>

    }
}

export default CustomField;